module.exports = __webpack_public_path__ + "static/media/youre-struggling.b7117f7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/convo-starts/youre-struggling.png
// module id = 1190
// module chunks = 2